export default "__VITE_ASSET__Cva6zNWO__"